import hasUserRole from "./hasUserRole";
export var isOrgAdmin = function isOrgAdmin(user, groupId) {
  return hasUserRole({
    groupId: groupId,
    name: "Org Admin",
    roleType: "primary",
    user: user
  });
};
export var isOversightAdmin = function isOversightAdmin(user, groupId) {
  return hasUserRole({
    groupId: groupId,
    name: "Oversight",
    roleType: "primary",
    user: user
  });
};
export var isReferralsAdmin = function isReferralsAdmin(user, groupId) {
  return hasUserRole({
    groupId: groupId,
    name: "Referrals Admin",
    roleType: "primary",
    user: user
  });
};
export var isReferralsAdminAndAbove = function isReferralsAdminAndAbove(user, groupId) {
  return isReferralsAdmin(user, groupId) || isOversightAdmin(user, groupId) || isOrgAdmin(user, groupId);
};
//# sourceMappingURL=checkRoles.js.map